import React from "react";

import FilterChips from "../../components/FilterChips";
import { Filter } from "../../components/FilterChips/FilterChips";

/**
 * The applied-filters chip row shared by the three Workflows pages.
 *
 * All three render the same row and delete a chip the same way; only the filter shape
 * and the chips it produces differ, so those are the two things a caller supplies.
 *
 * @param chipIdToFilterKeys Chips that own more than one filter key — a date-range chip
 * clears both its start and end. A chip id absent from the map clears the key of the same
 * name, which is the common case.
 */
export const ReadableFilterChipsShell = <TFilters extends object>({
	filters,
	setFilters,
	convert,
	chipIdToFilterKeys,
}: {
	filters: Partial<TFilters>;
	setFilters: (newFilters: Partial<TFilters>) => void;
	convert: (filters: Partial<TFilters>) => Filter[];
	chipIdToFilterKeys?: Record<string, (keyof TFilters)[]>;
}) => {
	const convertedFilters = convert(filters);

	if (convertedFilters.length === 0) {
		return null;
	}

	return (
		<div>
			{/* each chip has a built-in 2px vertical margin, so a 4px row gap yields 8px of visual vertical
			    spacing; the label's built-in margin is zeroed so the gap alone spaces it from the first chip */}
			<FilterChips
				className="flex flex-wrap items-center gap-x-2 gap-y-1 [&>[data-testid=mainLabel]]:!mr-0"
				filters={convertedFilters}
				label="Filters applied: "
				onDeleteFilter={(id) => {
					const currentFilters = { ...filters };
					for (const key of chipIdToFilterKeys?.[id] ?? [id as keyof TFilters]) {
						delete currentFilters[key];
					}

					setFilters({ ...currentFilters });
				}}
			/>
		</div>
	);
};

export default ReadableFilterChipsShell;
